import type { TFunction } from 'i18next';
import type { WizardStep } from '~/components/overlays/WizardModal';

export function wizardStepsFromTranslations<StepId extends string>(
  t: TFunction,
  keyPrefix: string,
  stepIds: readonly StepId[]
): WizardStep<StepId>[] {
  return stepIds.map((stepId) => ({
    id: stepId,
    label: t(`${keyPrefix}.step_${stepId}_label`),
    title: t(`${keyPrefix}.step_${stepId}_title`),
    description: t(`${keyPrefix}.step_${stepId}_subtitle`),
  }));
}
